/**
 * Root application configuration.
 * Translation: Root application configuration.
 */
const config = {
  amplify: {},
};

/**
 * Optional environment-backed Amplify configuration.
 * Translation: Optional environment-backed Amplify configuration.
 */
if (process.env.REACT_APP_COGNITO_REGION) {
  config.amplify.Auth = {
    mandatorySignIn: false,
    region: process.env.REACT_APP_COGNITO_REGION,
    userPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID,
    identityPoolId: process.env.REACT_APP_COGNITO_IDENTITY_POOL_ID,
    userPoolWebClientId: process.env.REACT_APP_COGNITO_APP_CLIENT_ID,
  };
}

if (process.env.REACT_APP_S3_REGION && process.env.REACT_APP_S3_BUCKET) {
  config.amplify.Storage = {
    region: process.env.REACT_APP_S3_REGION,
    bucket: process.env.REACT_APP_S3_BUCKET,
    identityPoolId: process.env.REACT_APP_COGNITO_IDENTITY_POOL_ID,
  };
}

if (process.env.REACT_APP_API_URL) {
  config.amplify.API = {
    endpoints: [
      {
        name: "dcl-brand-web-api",
        endpoint: process.env.REACT_APP_API_URL,
        region:
          process.env.REACT_APP_API_REGION || process.env.REACT_APP_COGNITO_REGION,
      },
    ],
  };
}

console.log("[VALUE] - Amplify config sections:", Object.keys(config.amplify));

export default config;
